import { get } from './utils';

export async function getDashboardSummaries(data) {
  return get(`/summaries/dashbroad`, data);
}
